import { Badge, Button } from "react-bootstrap";

const ApplicationListItem = ({appID,status,creationDate,lastActiveDate,selectCallback,navToHistory}) => {

    const _getConfig = () => {
        if(status === null){
            return {
                badgeClass : 'secondary',
                badgeText : 'Not Started',
                listingClass : 'notstarted',
                currentStatus : 'Not Started'
            }
        }

        switch (status.indicatortheme){
            case "INPROGRESS":
                return {
                    badgeClass : 'warning',
                    badgeText : 'In Progress',
                    listingClass : 'inprogress',
                    currentStatus : status.statustext
                }
            case "DENY":
                return {
                    badgeClass : 'danger',
                    badgeText : 'Denied',
                    listingClass : 'denied',
                    currentStatus : status.statustext
                }
            default:
                return {
                    badgeClass : 'success',
                    badgeText : 'Completed',
                    listingClass : 'completed',
                    currentStatus : status.statustext
                }
        }
    }

    const config = _getConfig();

    return(
        <div className={`applicationListing ${config.listingClass}`}>
            <div className="d-flex justify-content-between">
                <h5 className="mb-0">{appID}</h5>
                <div>
                    {navToHistory ? (
                        <Button type="button" title="View History" aria-label="View History" variant="outline-secondary" size="sm" className="me-1" onClick={navToHistory}>View History</Button>
                    ) : null}
                    {selectCallback ? (
                        <Button type="button" title="Select Application" aria-label="Select Application" variant="outline-primary" size="sm" onClick={selectCallback}>Select</Button>
                    ) : null}
                </div>
            </div>
                <Badge pill bg={config.badgeClass}>{config.badgeText}</Badge>
                <h6 className="mb-0">Current Status</h6>
                <p>{config.currentStatus}</p>
                <h6 className="mb-0">Application Creation Date</h6>
                <p>{creationDate}</p>
                <h6 className="mb-0">Last Activity Date</h6>
                <p>{lastActiveDate}</p>
        </div>
    )
}

export default ApplicationListItem;
